var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditUnderline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_2051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00976562,
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42627 16.9998V14.1665H15.5929V16.9998H1.42627ZM4.2596 11.3332H5.25127L10.7763 5.82588L9.7669 4.8165L4.2596 10.3415V11.3332ZM2.84294 12.7498V9.73942L10.7763 1.8238C10.9061 1.69393 11.0567 1.59359 11.2278 1.52275C11.399 1.45192 11.579 1.4165 11.7679 1.4165C11.9568 1.4165 12.1398 1.45192 12.3169 1.52275C12.494 1.59359 12.6534 1.69984 12.795 1.8415L13.769 2.83317C13.9106 2.96303 14.0139 3.1165 14.0789 3.29359C14.1438 3.47067 14.1763 3.65366 14.1763 3.84255C14.1763 4.01963 14.1438 4.19376 14.0789 4.36494C14.0139 4.53612 13.9106 4.69255 13.769 4.83421L5.85335 12.7498H2.84294Z",
    fill: "#1C74D0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUnderline);
export default __webpack_public_path__ + "static/media/edit-underline.3a592c0ddb9969e9b8225b3add627de8.svg";
export { ForwardRef as ReactComponent };